module.exports = __webpack_public_path__ + "img/ic-help-toc-blight.3b130e89.svg";